<template>
  <div class="c-project-archive-card">
    <div class="c-project-archive-card__figure">
      <div v-if="entry.images.length > 1">
        <div class="js-project-card-gallery">
          <div v-for="image in entry.images" :key="image.id">
            <img :src="image.url" alt="">
          </div>
        </div>
        <button class="c-project-archive-card__btn c-project-archive-card__btn--prev js-project-card-gallery__prev">
          <img src="@/assets/caret-left-blue.svg" height="32" alt="Left caret">
        </button>
        <button class="c-project-archive-card__btn c-project-archive-card__btn--next js-project-card-gallery__next">
          <img src="@/assets/caret-right-blue.svg" height="32" alt="Right caret">
        </button>
      </div>
      <div v-else>
        <img :src="entry.images[0].url" :alt="entry.title">
      </div>
    </div>
    <router-link class="c-project-archive-card__heading-link" :to="{ name: 'project', params: { slug: entry.slug }}">
      <h4 class="c-project-archive-card__heading u-h3">{{ entry.title }}</h4>
    </router-link>
    <p class="c-project-archive-card__summary u-st1" v-if="entry.summary">{{ entry.summary }}</p>
    <div class="u-st2 u-hl-grey-1" v-if="entry.startDate">Project Dates: {{ entry.startDate.date }} &ndash; {{ entry.endDate.date }}</div>
  </div>
</template>

<script>
import Siema from 'siema'
import moment from 'moment'

export default {
  name: 'ProjectArchiveCard',
  props: {
    entry: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.initSemia()
    this.entry.startDate.date = moment(this.entry.startDate.date).format('D MMMM YYYY')
    this.entry.endDate.date = moment(this.entry.endDate.date).format('D MMMM YYYY')
  },
  watch: {
    entry: function (newEntry, oldEntry) {
      this.entry.startDate.date = moment(this.entry.startDate.date).format('D MMMM YYYY')
      this.entry.endDate.date = moment(this.entry.endDate.date).format('D MMMM YYYY')
    }
  },
  methods: {
    initSemia () {
      const siema = new Siema({
        selector: this.$el.querySelector('.js-project-card-gallery'),
        loop: true,
        draggable: false,
        duration: 800
      })
      this.$el.querySelector('.js-project-card-gallery__prev').addEventListener('click', () => siema.prev())
      this.$el.querySelector('.js-project-card-gallery__next').addEventListener('click', () => siema.next())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProjectArchiveCard.vue